import { AppointmentDataGetter } from './AppointmentDataGetter'
import { KeysDeliveryAppointmentDataGetter } from './KeysDeliveryAppointmentDataGetter'
import { VisitationToConstructionAppointmentDataGetter } from './VisitationToConstructionAppointmentDataGetter'
import { GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations } from '../../../services/types/GetUserKeysDeliveryEventInvitations'
import { EventTypes } from '../constants'
import { GetAvailableVisitationRaffles_listUserVisitEvents } from '../../../services/types/getAvailableVisitationRaffles'

export type Appointment =
  | GetAvailableVisitationRaffles_listUserVisitEvents
  | GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations

interface CallbackFunctions {
  onPressCancelKeysDelivery: (invitationId: string, eventId: string, constructionName: string) => void
  onPressConfirmKeysDelivery: (invitationId: string, eventId: string) => void
  onPressCancelVisitation: (id: string) => void
  onPressConfirmVisitation: (id?: string) => void
}

export class AppointmentDataFactory {
  callbackFunctions: CallbackFunctions
  public keysDeliveryDataGetter: AppointmentDataGetter
  public visitationToConstructionAppointmentDataGetter: AppointmentDataGetter

  constructor(callbackFunctions: CallbackFunctions) {
    this.callbackFunctions = callbackFunctions

    const {
      onPressConfirmKeysDelivery,
      onPressCancelKeysDelivery,
      onPressConfirmVisitation,
      onPressCancelVisitation,
    } = callbackFunctions
    this.keysDeliveryDataGetter = new KeysDeliveryAppointmentDataGetter({
      onPressConfirmKeysDelivery,
      onPressCancelKeysDelivery,
    })
    this.visitationToConstructionAppointmentDataGetter = new VisitationToConstructionAppointmentDataGetter({
      onPressConfirmVisitation,
      onPressCancelVisitation,
    })
  }

  public getDataGetter(appointment: any): AppointmentDataGetter | null {
    switch (appointment?.type) {
      case EventTypes.KEYS_DELIVERY:
        return this.keysDeliveryDataGetter
      case EventTypes.VISIT_TO_CONSTRUCTION:
        return this.visitationToConstructionAppointmentDataGetter
      default:
        return this.keysDeliveryDataGetter
    }
  }
}
